// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ACSCache } from './ACSCache';
import { ACSKey } from './ACSTypes';

export class ACSHelperLoggerUtils {
  public static async printAllKnownKeys(cache: ACSCache | null) {
    if (!cache) {
      console.log('Long term caching of ACS is disabled!');
      return;
    }

    const allKnownKeys = new Set<string>();

    (await cache.getAllKeys()).forEach((key) => {
      allKnownKeys.add(key);
    });

    console.log(Array.from(allKnownKeys));
  }

  public static async downloadLogByKey(key: ACSKey, cache: ACSCache | null) {
    if (!cache) {
      console.log('Long term caching of ACS is disabled! No logs stored...');
      return;
    }

    console.log(`Trying to read logs for key: "${key}".`);

    const serializedContainer = await cache.get(key);

    const log = serializedContainer?.log;

    if (!log) {
      console.warn(`No ACS log found for key "${key}".`);
      return;
    }

    const downloadAnchor = document.createElement('a');

    const contentType = 'data:text/plain;charset=utf-8,';

    downloadAnchor.setAttribute('href', contentType + encodeURIComponent(`[${log}]`));
    downloadAnchor.setAttribute('download', `LOGS_${key}.json`);

    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    document.body.removeChild(downloadAnchor);
  }
}
